import React from 'react';
import { Filter, X } from 'lucide-react';

export default function FilterToolbar({ filters, onFiltersChange }) {
  const statusOptions = [
    { value: 'all', label: 'Todos os Status' },
    { value: 'paid', label: 'Pago' },
    { value: 'pending', label: 'Pendente' },
    { value: 'overdue', label: 'Atrasado' },
    { value: 'partial', label: 'Parcial' }
  ];

  const operatorOptions = [
    { value: 'all', label: 'Todos os Operadores' },
    { value: 'Rita', label: 'Rita' },
    { value: 'João', label: 'João' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'Todo o Período' },
    { value: '7days', label: 'Últimos 7 dias' },
    { value: '30days', label: 'Últimos 30 dias' },
    { value: '90days', label: 'Últimos 90 dias' }
  ];

  const handleReset = () => {
    onFiltersChange({
      status: 'all',
      dateRange: 'all',
      operator: 'all',
      amountRange: { min: 0, max: 999999 }
    });
  };

  const hasActiveFilters = filters?.status !== 'all' || 
                          filters?.dateRange !== 'all' || 
                          filters?.operator !== 'all';

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Filter size={18} className="text-gray-600" />
          <h3 className="font-semibold text-gray-900">Filtros</h3>
        </div>
        {hasActiveFilters && (
          <button
            onClick={handleReset}
            className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700"
          >
            <X size={16} />
            Limpar Filtros
          </button>
        )}
      </div>
      <div className="grid grid-cols-3 gap-4">
        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <select
            value={filters?.status}
            onChange={(e) => onFiltersChange({ ...filters, status: e?.target?.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            {statusOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Período
          </label>
          <select
            value={filters?.dateRange}
            onChange={(e) => onFiltersChange({ ...filters, dateRange: e?.target?.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            {dateRangeOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Operator Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Operador
          </label>
          <select
            value={filters?.operator}
            onChange={(e) => onFiltersChange({ ...filters, operator: e?.target?.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            {operatorOptions?.map(option => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}